
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryOrContentPageSlug]/personalise/summary",
      function () {
        return require("private-next-pages/[categoryOrContentPageSlug]/personalise/summary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryOrContentPageSlug]/personalise/summary"])
      });
    }
  